import React, { useEffect, useState, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import moment from 'moment';
import { Endpiont } from 'shared/utils/Endpoints';
import { HTTP_CLIENT } from 'shared/utils/Interceptor';
import * as XLSX from 'xlsx';
import styles from './style.module.scss';
import classNames from 'classnames';
import Heading from 'shared/components/common/heading/Heading';
import CustomInput from 'shared/components/common/custom_input/CustomInput';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import { useSelector } from 'react-redux';
import CustomSelect from 'shared/components/common/custom_selection/CustomSelection';
import DashboardWrapper from 'shared/components/common/dashboard_wrapper/DashboardWrapper';
import { GetAllCategoryQuery } from 'shared/services/category_service/CategoryService';
import { GetAllSubCategoryQuery } from 'shared/services/sub_category_service/SubCategoryService';
import { GetAllProductQuery } from 'shared/services/product_service/ProductService';
import { GetAllBrandQuery } from 'shared/services/brand_service/BrandService';
import { useFormik } from 'formik';
import OverlayLoading from 'shared/screen_loader/overlay_loader/OverlayLoading';
import { PoVS } from 'shared/utils/validation/AuthValidation';
import * as yup from 'yup';
import { AddRoughListingMutation, GetAllRoughListingQuery, AssignSkuMutation, UpdateRoughListingMutation, CreateTasksFromRLMutation, checkVariantExists } from 'shared/services/rough_listing_service/RoughListingService';
import { useNavigate, useLocation } from 'react-router-dom';
import { routeConstant } from 'shared/routes/RouteConstant';
import Select from 'react-select';
import InnerRlTable from './InnerRlTable';
import PurchaseOrderSuplierModal from 'shared/modal/purchase_order_supplier/PurchaseOrderSupplier';
import { isRestrictActions, hasActionPermission } from 'shared/utils/Helper';
import { screenActionEnum, screenEnum, roleEnum } from 'shared/utils/Enum';
import UploadAvatar from 'shared/components/common/upload_avatar/UploadAvatar';
import { uploadFileMedia } from 'shared/services/media_service/Media_Service';
import UploadAvatarArray from 'shared/components/common/upload_avatar/UploadAvatarArray';
import { GetAllCompetibleBrandQuery } from 'shared/services/competible_brand_service/CompetibleBrandService';
import { GetAllColors } from 'shared/services/color_services/ColorsServices';
import { toast } from 'react-toastify';
import AddBrand from 'shared/modal/add_brand/AddBrand';
import AddCompetibleBrand from 'shared/modal/add_competible_brand/AddCompetibleBrand';
import AddCategory from 'shared/modal/add_category/AddCategory';
import AddSubCategory from 'shared/modal/add_sub_category/AddSubCategory';
import AddColors from 'shared/modal/add_color/AddColors';
import AddProduct from 'shared/modal/add_product/AddProduct';
import { GetAllWarehouse } from 'shared/services/ware_house_service/WareHouseService';

export default function AddRoughListing({ show, handleClose, isEdit = false }) {
    const { mutate: addPOMutation, isLoading: POLoading } = AddRoughListingMutation();
    const { mutate: assignSkuMutate, isLoading: assignSkuLoading } = AssignSkuMutation();
    const { mutate: updatePOMutation, isLoading: updatePOLoading } = UpdateRoughListingMutation();
    const { mutate: createTasksMutate, isLoading: createTasksLoading, isSuccess: createTasksSuccess } = CreateTasksFromRLMutation();
    const isSaving = assignSkuLoading || updatePOLoading || POLoading;
    const [tasksAlreadyCreated, setTasksAlreadyCreated] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const { data: listCategory } = GetAllCategoryQuery();
    const { data: listSubCategory } = GetAllSubCategoryQuery();
    const { data: listProduct } = GetAllProductQuery();
    const { data: listBrnd } = GetAllBrandQuery();
    const { data: listCompetebleBrnd } = GetAllCompetibleBrandQuery();
    const { data: colorlist } = GetAllColors();
    const { data: PoList } = GetAllRoughListingQuery();
    const [selectedBaseSku, setSelectedBaseSku] = useState(null); // base SKU from SKU dropdown e.g. 'wt000322'
    const [grandSkuTarget, setGrandSkuTarget] = useState(null); // { parentItem, parentSku, nextSku, nextDigit }




    const [avatarFile, setAvatarFile] = useState(null);
    const [selectedImg, setSelectedImg] = useState('');
    const [avatarFileArray, setAvatarFileArray] = useState([]);
    const [colorarray, setarraycolor] = useState([]);
    const {
        theme: { theme },
        user
    } = useSelector((state) => state.root);
    const [ModelList, setModelList] = useState([]);
    const [CatList, setCatList] = useState(listCategory);
    const [SubCatlList, setSubCatList] = useState([]);
    const [currencyList, setCurrencyList] = useState('');
    const [editDraftData, setEditDraftData] = useState(null);
    const isLocked = false;

    useEffect(() => {
        // Bug 2 fix: if we just got fresh data from a local save, skip PoList override
        // to prevent stale refetch from overwriting correct badge data
        if (recentLocalSaveRef.current) return;
        if (location.state?.editData) {
            let draft = location.state.editData;
            // Fallback to query list to get the most up-to-date data if available
            if (PoList) {
                const latestDraft = PoList.find(po => po._id === draft._id);
                if (latestDraft) {
                    draft = latestDraft;
                }
            }
            setEditDraftData(draft);
            if (draft.order && Array.isArray(draft.order)) {
                const mappedOrder = draft.order.map(item => ({
                    _id: item._id,
                    product: item.product,
                    product_category: item.product_category,
                    competebleBrand: item.compatiableBrand,
                    sub_category: item.sub_category,
                    brand: item.brand,
                    quantity: item.quantity,
                    price: item.price,
                    color: item.color,
                    raw_images: item.raw_images || [],
                    description: draft.description || "",
                    sku: item.sku,
                    status: item.status || 'pending',
                    badge: item.badge,
                    task_created: item.task_created || false,
                    parentChildSku: item.parentChildSku || null
                }));
                setPoListing(mappedOrder);
            }
        }
    }, [location.state, PoList]);

    const [isEdits, setIsEdit] = useState(true);
    const [PoListing, setPoListing] = useState(() => {
        const isEditing = !!(window.history?.state?.usr?.editData);
        if (!isEditing) {
            try {
                const stored = sessionStorage.getItem('temp_rough_listing_order');
                return stored ? JSON.parse(stored) : [];
            } catch (e) {
                return [];
            }
        }
        return [];
    });
    const [approvingIndex, setApprovingIndex] = useState(null);
    const hasItemsWithoutSku = PoListing.some(item => !item.sku || item.sku === 'N/A' || item.sku === '');
    const [editingIndex, setEditingIndex] = useState(null);
    const [SupplierVal, setSupplierVal] = useState('');
    const [modalShow, setShowModal] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [isProcessingExcel, setIsProcessingExcel] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showBrandModal, setShowBrandModal] = useState(false);
    const [showCompatibleBrandModal, setShowCompatibleBrandModal] = useState(false);
    const [showModelModal, setShowModelModal] = useState(false);
    const [showCatModal, setShowCatModal] = useState(false);
    const [showSubCatModal, setShowSubCatModal] = useState(false);
    const [showColorModal, setShowColorModal] = useState(false);
    // Apply-to-batch modal state

    const closeProductHandler = () => {

        setShowBrandModal(false);
        setShowCompatibleBrandModal(false);
        setShowCatModal(false);
        setShowSubCatModal(false);
        setShowColorModal(false);
        setShowModelModal(false);
    }

    const [newlyAddedItem, setNewlyAddedItem] = useState({ type: null, value: null });
    const [showAlertModal, setShowAlertModal] = useState(false);
    const [matchedSkuAlert, setMatchedSkuAlert] = useState('');
    const [pendingApproveIndex, setPendingApproveIndex] = useState(null);

    const handleSuccessAdd = (type, value) => {
        setNewlyAddedItem({ type, value });
    };

    useEffect(() => {
        if (!colorlist || colorlist.length === 0) {
            setarraycolor([]); // ✅ Clear color array if no data
            return;
        }

        const mapped = colorlist.map(ii => ({
            ...ii,
            label: ii?.color || '',
            value: ii?.color || '',
        }));

        setarraycolor(mapped);
    }, [colorlist]);

    const skuOptions = React.useMemo(() => {
        if (!PoList) return [];
        const seenSkus = new Set();
        const options = [];
        
        PoList.forEach(rl => {
            rl.order?.forEach(orderItem => {
                if (orderItem?.sku && !seenSkus.has(orderItem.sku) && orderItem.status === 'approved') {
                    seenSkus.add(orderItem.sku);
                    const parts = [
                        orderItem.sku,
                        orderItem.brand?.name,
                        orderItem.compatiableBrand?.name,
                        orderItem.product?.name,
                        orderItem.product_category?.name,
                        orderItem.sub_category?.name,
                        orderItem.color
                    ].filter(Boolean);

                    options.push({
                        label: parts.join(' - '),
                        value: orderItem.sku,
                        fullData: orderItem
                    });
                }
            });
        });
        return options;
    }, [PoList]);

    const badgeOptions = React.useMemo(() => {
        const existingBadges = [...new Set(PoListing.map(item => item.badge || 1))];
        if (existingBadges.length === 0) {
            return [{ label: 'Batch 1', value: 1 }];
        }
        existingBadges.sort((a, b) => a - b);
        const options = existingBadges.map(b => ({
            label: `Batch ${b}`,
            value: b
        }));
        const nextBadge = Math.max(...existingBadges) + 1;
        options.push({
            label: `+ New Batch (Batch ${nextBadge})`,
            value: nextBadge
        });
        return options;
    }, [PoListing]);




    console.log(showBrandModal, "showBrandModal");

    const RlVS = yup.object().shape({
        color: yup.mixed().required('Color is Required').label('color'),
        price: yup.string().required('Price is Required').label('price'),
        quantity: yup.string().required('Quantity is Required').label('quantity'),
        description: yup.mixed().label('description'),
    }).test(
        'at-least-one-field',
        null,
        function (values) {
            const { brand, competebleBrand, model, ProductCategory, SubCategory } = values;
            const hasAtLeastOne = !!(brand || competebleBrand || model || ProductCategory || SubCategory);
            if (!hasAtLeastOne) {
                return new yup.ValidationError(
                    'At least one field (Brand, Compatible Brand, Model, Category, or Sub Category) is required',
                    null,
                    'brand'
                );
            }
            return true;
        }
    );

    const initialValues = {
        model: '',
        brand: '',
        competebleBrand: '',
        ProductCategory: '',
        SubCategory: '',
        price: '0', // Default '0' so validation passes when hidden
        currency: '',
        quantity: '1', // Default '1' so validation passes when hidden
        description: '',
        color: '',
        badge: 1
    };

    const customFilter = (option, inputValue) => {
        if (!inputValue) return true;
        
        const searchTerms = inputValue.toLowerCase().split(' ').filter(term => term.length > 0);
        const data = option.data?.fullData || {};
        
        // Build a searchable string of all relevant matching fields
        const searchableText = `
            ${option.label || ""} 
            ${data.brand?.name || ""} 
            ${data.compatiableBrand?.name || ""} 
            ${data.product?.name || ""} 
            ${data.product_category?.name || ""} 
            ${data.sub_category?.name || ""} 
            ${data.color || ""}
        `.toLowerCase();
        
        // Ensure ALL search terms from user input are found in the searchable text
        return searchTerms.every(term => searchableText.includes(term));
    };

    // ─── Draft Form Fields Persistence (5s restore window, isolated per page) ──────
    const RL_DRAFT_FORM_KEY = 'temp_rl_draft_form_fields';
    const PO_DRAFT_FORM_KEY = 'temp_po_draft_form_fields'; // to cross-clear
    const RL_DRAFT_RESTORE_MS = 5000; // 5 seconds
    const rlDraftRestoredRef = useRef(false);
    const suppressDraftSaveRef = useRef(false); // Bug 1 fix: prevent re-save of old values after form reset
    const recentLocalSaveRef = useRef(false);   // Bug 2 fix: prevent PoList refetch from overwriting fresh badge data
    const isSavingRef = useRef(false);          // Prevent duplicate draft creation on double click / rapid save

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validationSchema: RlVS,
        onSubmit: (values) => {
            // --- Determine badge from grandSkuTarget or selectedBaseSku ---
            let resolvedBadge = values.badge || 1;
            if (grandSkuTarget) {
                resolvedBadge = grandSkuTarget.parentItem?.badge || values.badge || 1;
            } else if (selectedBaseSku && editingIndex === null) {
                // Find existing item in PoListing that has this baseSku
                const matchedItem = PoListing.find(item => {
                    const base = item.sku?.match(/^wt\d{6}/)?.[0];
                    return base === selectedBaseSku;
                });
                if (matchedItem) {
                    resolvedBadge = matchedItem.badge || 1;
                } else {
                    // No item in current listing with this baseSku — keep form badge
                    resolvedBadge = values.badge || 1;
                }
            }

            let newItem = {
                _id: editingIndex !== null ? PoListing[editingIndex]?._id : undefined,
                product: values.model,
                brand: values.brand,
                competebleBrand: values.competebleBrand,
                product_category: values.ProductCategory,
                sub_category: values.SubCategory,
                quantity: values.quantity,
                price: values.price,
                currency: values.currency,
                description: values.description,
                color: values.color?.label || values.color,
                badge: resolvedBadge,
                sku: grandSkuTarget ? grandSkuTarget.nextSku : (editingIndex !== null ? PoListing[editingIndex]?.sku : undefined),
                parentChildSku: grandSkuTarget ? grandSkuTarget.parentSku : (editingIndex !== null ? PoListing[editingIndex]?.parentChildSku : undefined),
                status: editingIndex !== null ? PoListing[editingIndex]?.status : undefined,
                task_created: editingIndex !== null ? PoListing[editingIndex]?.task_created : false,
                // Pass baseSkuHint so backend knows which parent SKU to extend
                baseSkuHint: (selectedBaseSku && editingIndex === null && !grandSkuTarget) ? selectedBaseSku : undefined
            };

            // --- Detect if this item is EXACTLY an existing SKU (no change) ---
            // If user selected a SKU and added same color/details without change → mark as existing
            if (selectedBaseSku && editingIndex === null && !grandSkuTarget) {
                const selectedSkuOption = PoList?.flatMap(rl => rl.order || []).find(orderItem =>
                    orderItem.sku && orderItem.sku.match(/^wt\d{6}/)?.[0] === selectedBaseSku &&
                    orderItem.color === newItem.color &&
                    (orderItem.product?._id || orderItem.product)?.toString() === (newItem.product?._id || newItem.product)?.toString() &&
                    (orderItem.brand?._id || orderItem.brand)?.toString() === (newItem.brand?._id || newItem.brand)?.toString() &&
                    (orderItem.compatiableBrand?._id || orderItem.compatiableBrand)?.toString() === (newItem.competebleBrand?._id || newItem.competebleBrand)?.toString() &&
                    (orderItem.product_category?._id || orderItem.product_category)?.toString() === (newItem.product_category?._id || newItem.product_category)?.toString() &&
                    (orderItem.sub_category?._id || orderItem.sub_category)?.toString() === (newItem.sub_category?._id || newItem.sub_category)?.toString()
                );
                if (selectedSkuOption) {
                    // Exact match — assign existing SKU and mark as existing
                    newItem.sku = selectedSkuOption.sku;
                    newItem.isExisting = true;
                    newItem.status = 'existing';
                }
            }

            newItem['raw_images'] = avatarFileArray;

            // Check for duplicates (excluding the item currently being edited)
            // If newItem already has a specific SKU (e.g. Grand SKU wt000001g0), duplicate only if exact same SKU is already present
            const isDuplicate = PoListing.some((item, idx) => {
                if (idx === editingIndex) return false;

                if (newItem.sku) {
                    return item.sku && item.sku.toLowerCase() === newItem.sku.toLowerCase();
                }

                const sameProduct = (item.product?._id || item.product)?.toString() === (newItem.product?._id || newItem.product)?.toString();
                const sameBrand = (item.brand?._id || item.brand)?.toString() === (newItem.brand?._id || newItem.brand)?.toString();
                const sameCompatBrand = (item.competebleBrand?._id || item.competebleBrand || item.compatiableBrand?._id || item.compatiableBrand)?.toString() === (newItem.competebleBrand?._id || newItem.competebleBrand)?.toString();
                const sameCat = (item.product_category?._id || item.product_category)?.toString() === (newItem.product_category?._id || newItem.product_category)?.toString();
                const sameSubCat = (item.sub_category?._id || item.sub_category)?.toString() === (newItem.sub_category?._id || newItem.sub_category)?.toString();
                const sameColor = (item.color || '').toString().toLowerCase() === (newItem.color || '').toString().toLowerCase();

                return sameProduct && sameBrand && sameCompatBrand && sameCat && sameSubCat && sameColor;
            });

            if (isDuplicate) {
                toast.error("This item already exists in the list.");
                return; // Prevent adding duplicate
            }

            const currentBadge = resolvedBadge;
            let updatedList = [...PoListing];
            if (editingIndex !== null) {
                updatedList[editingIndex] = newItem;
                setPoListing(updatedList);
                setEditingIndex(null);
                toast.success("Item updated in the list!");
                if (editDraftData) savePoListing(updatedList, true);
                suppressDraftSaveRef.current = true; // Bug 1 fix: block re-save before reset completes
                sessionStorage.removeItem(RL_DRAFT_FORM_KEY);
                rlDraftRestoredRef.current = false;
                setIsEdit(true);
                formik.resetForm({ values: { ...initialValues, badge: currentBadge } }); // atomic reset — no intermediate state
                setAvatarFileArray([]);
                setSelectedBaseSku(null);
                setGrandSkuTarget(null);

                // If opened from Manage Task, navigate back to Task Management screen after update
                if (location.state?.fromTask || location.state?.editSku) {
                    setTimeout(() => {
                        navigate(routeConstant.admin.manageTask.path);
                    }, 500);
                }
                return;
            } else {
                if (grandSkuTarget) {
                    // Find position of parent or its last sub-sku in updatedList to insert directly beneath it
                    const parentSku = (grandSkuTarget.parentSku || "").toLowerCase();
                    let insertIndex = -1;
                    for (let i = updatedList.length - 1; i >= 0; i--) {
                        const itemSku = (updatedList[i].sku || "").toLowerCase();
                        const itemParent = (updatedList[i].parentChildSku || "").toLowerCase();
                        if (itemSku === parentSku || itemParent === parentSku || itemSku.startsWith(parentSku)) {
                            insertIndex = i + 1;
                            break;
                        }
                    }
                    if (insertIndex !== -1) {
                        updatedList.splice(insertIndex, 0, newItem);
                    } else {
                        updatedList.push(newItem);
                    }
                    toast.success(`Sub-SKU ${grandSkuTarget.nextSku} added to the list!`);
                } else {
                    updatedList.push(newItem);
                    toast.success("Item added to the list!");
                }
            }
            setPoListing(updatedList);

            if (editDraftData) {
                savePoListing(updatedList, true);
            }

            // Clear draft form fields once item is added
            suppressDraftSaveRef.current = true; // Bug 1 fix: block re-save before reset completes
            sessionStorage.removeItem(RL_DRAFT_FORM_KEY);
            rlDraftRestoredRef.current = false;

            // Reset form states
            setIsEdit(true);
            formik.resetForm({ values: { ...initialValues, badge: currentBadge } }); // atomic reset — no intermediate state
            setAvatarFileArray([]);
            setSelectedBaseSku(null);
            setGrandSkuTarget(null);
        }

    });
    const { handleChange, setFieldValue, handleSubmit, values, touched, errors } = formik;

    // On mount: cross-clear PO draft, then restore RL draft if within 5s
    useEffect(() => {
        // Always clear the OTHER page's draft to prevent cross-contamination
        sessionStorage.removeItem(PO_DRAFT_FORM_KEY);

        if (rlDraftRestoredRef.current) return;
        if (editDraftData) return; // skip when editing existing
        if (window.history?.state?.usr?.editData) return; // skip on edit route
        try {
            const raw = sessionStorage.getItem(RL_DRAFT_FORM_KEY);
            if (!raw) return;
            const { values: saved, timestamp } = JSON.parse(raw);
            const ageMs = Date.now() - timestamp;
            if (ageMs <= RL_DRAFT_RESTORE_MS && saved) {
                Object.keys(saved).forEach(key => {
                    if (saved[key] !== '' && saved[key] !== null && saved[key] !== undefined) {
                        formik.setFieldValue(key, saved[key]);
                    }
                });
                rlDraftRestoredRef.current = true;
            } else {
                // Expired — remove stale draft
                sessionStorage.removeItem(RL_DRAFT_FORM_KEY);
            }
        } catch (_) {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editDraftData]);

    // Save form values to sessionStorage whenever a meaningful field is filled
    // Only when NOT editing an existing RL draft
    useEffect(() => {
        if (editDraftData) return; // skip when editing existing
        const hasMeaningfulValue = (
            (values.brand && (values.brand._id || values.brand.label)) ||
            (values.competebleBrand && (values.competebleBrand._id || values.competebleBrand.label)) ||
            (values.model && (values.model._id || values.model.label)) ||
            (values.ProductCategory && (values.ProductCategory._id || values.ProductCategory.label)) ||
            (values.SubCategory && (values.SubCategory._id || values.SubCategory.label)) ||
            (values.color && (values.color._id || values.color.label)) ||
            (values.price && values.price !== '' && values.price !== '0') ||
            (values.quantity && values.quantity !== '' && values.quantity !== '1') ||
            (values.description && values.description !== '')
        );
        // Bug 1 fix: if we just submitted/reset the form, don't re-save old values
        if (suppressDraftSaveRef.current) {
            if (hasMeaningfulValue) {
                suppressDraftSaveRef.current = false; // user started filling next item — allow save again
            } else {
                return; // form is still resetting — skip save
            }
        }
        if (hasMeaningfulValue) {
            sessionStorage.setItem(RL_DRAFT_FORM_KEY, JSON.stringify({ values, timestamp: Date.now() }));
        }
    }, [values, editDraftData]);

    useEffect(() => {
        listCategory?.map((ii) => {
            ii['label'] = ii?.name;
            ii['value'] = ii?.name;
            return ii;
        });
        listProduct?.map((ii) => {
            ii['label'] = ii?.name;
            ii['value'] = ii?.name;
            return ii;
        });
        listSubCategory?.map((ii) => {
            ii['label'] = ii?.name;
            ii['value'] = ii?.name;
            return ii;
        });
        listBrnd?.map((ii) => {
            ii['label'] = ii?.name;
            ii['value'] = ii?.name;
            return ii;
        });
        listCompetebleBrnd?.map((ii) => {
            ii['label'] = ii?.name;
            ii['value'] = ii?.name;
            return ii;
        });


    }, [listCategory, listSubCategory, listProduct, listBrnd, listCompetebleBrnd,]);

    // Keep SubCatList updated when listSubCategory updates (after adding new sub category)
    useEffect(() => {
        if (values.ProductCategory && values.ProductCategory._id) {
            setSubCatList(listSubCategory?.filter((ii) => values.ProductCategory._id === (ii?.category?._id || ii?.category)) || []);
        } else {
            setSubCatList(listSubCategory || []);
        }
    }, [listSubCategory, values.ProductCategory]);

    // Keep ModelList updated when listProduct updates (after adding new model)
    useEffect(() => {
        if (values.competebleBrand && values.competebleBrand._id) {
            setModelList(listProduct?.filter((ii) => values.competebleBrand._id === (ii?.compatiableBrand?._id || ii?.compatiableBrand)) || []);
        } else {
            setModelList(listProduct || []);
        }
    }, [listProduct, values.competebleBrand]);


    // Auto-select newly added item once it's available in the list
    useEffect(() => {
        if (!newlyAddedItem.type || !newlyAddedItem.value) return;

        const { type, value } = newlyAddedItem;
        const lowercaseValue = value.trim().toLowerCase();

        if (type === 'brand' && listBrnd) {
            const found = listBrnd.find(item => item?.name?.trim().toLowerCase() === lowercaseValue);
            if (found) {
                setFieldValue('brand', Object.assign({}, found, { label: found.name, value: found.name }));
                setNewlyAddedItem({ type: null, value: null });
            }
        } else if (type === 'competebleBrand' && listCompetebleBrnd) {
            const found = listCompetebleBrnd.find(item => item?.name?.trim().toLowerCase() === lowercaseValue);
            if (found) {
                setFieldValue('competebleBrand', Object.assign({}, found, { label: found.name, value: found.name }));
                setNewlyAddedItem({ type: null, value: null });
            }
        } else if (type === 'category' && listCategory) {
            const found = listCategory.find(item => item?.name?.trim().toLowerCase() === lowercaseValue);
            if (found) {
                setFieldValue('ProductCategory', Object.assign({}, found, { label: found.name, value: found.name }));
                setNewlyAddedItem({ type: null, value: null });
            }
        } else if (type === 'subCategory' && SubCatlList) { // Use filtered SubCatlList
            const found = SubCatlList.find(item => item?.name?.trim().toLowerCase() === lowercaseValue);
            if (found) {
                setFieldValue('SubCategory', Object.assign({}, found, { label: found.name, value: found.name }));
                setNewlyAddedItem({ type: null, value: null });
            }
        } else if (type === 'model' && ModelList) { // Use filtered ModelList
            const found = ModelList.find(item => item?.name?.trim().toLowerCase() === lowercaseValue);
            if (found) {
                setFieldValue('model', Object.assign({}, found, { label: found.name, value: found.name }));
                setNewlyAddedItem({ type: null, value: null });
            }
        } else if (type === 'color' && colorarray) {
            const found = colorarray.find(item => item?.color?.trim().toLowerCase() === lowercaseValue);
            if (found) {
                setFieldValue('color', Object.assign({}, found, { label: found.color, value: found.color }));
                setNewlyAddedItem({ type: null, value: null });
            }
        }
    }, [listBrnd, listCompetebleBrnd, listCategory, SubCatlList, ModelList, colorarray, newlyAddedItem, setFieldValue]);

    const customAddBrandOption = {
        label: "+ Add New",
        value: "__add_new__"
    };

    const brandOptions = [
        customAddBrandOption,
        ...(Array.isArray(listBrnd) ? listBrnd : [])
    ];
    const listCompetebleBrndOptions = [
        customAddBrandOption,
        ...(Array.isArray(listCompetebleBrnd) ? listCompetebleBrnd : [])
    ];
    const ModelListOptions = [
        customAddBrandOption,
        ...(Array.isArray(ModelList) ? ModelList : [])
    ];
    const SubCatlListOptions = [
        customAddBrandOption,
        ...(Array.isArray(SubCatlList) ? SubCatlList : [])
    ];
    const listCategoryOptions = [
        customAddBrandOption,
        ...(Array.isArray(listCategory) ? listCategory : [])
    ];
    const colorarrayOptions = [
        customAddBrandOption,
        ...(Array.isArray(colorarray) ? colorarray : [])
    ];

    const cleanId = (val) => {
        if (!val) return undefined;
        let id = typeof val === 'object' ? val._id : val;
        if (typeof id === 'string' && /^[0-9a-fA-F]{24}$/.test(id.trim())) {
            return id.trim();
        }
        return undefined;
    };

    const SubmmitPo = async (suplierObj) => {
        let obj = {
            order: [],
            supplier: suplierObj.supplier,
            description: '',
            status: 'completed'
        };


        PoListing.forEach((item) => {
            const isScreenProtector = String(item.product_category?.name || "").toLowerCase() === "screen protector";

            // Decide color value
            let colorValue = item.color;
            if (isScreenProtector) {
                // Ignore color for Screen Protector, make it "Transparent" if blank
                colorValue = "Transparent";
            }
            obj.order.push({
                _id: item._id,
                product: cleanId(item.product),
                product_category: cleanId(item.product_category),
                compatiableBrand: cleanId(item.competebleBrand) || cleanId(item.compatiableBrand),
                sub_category: cleanId(item.sub_category),
                brand: cleanId(item.brand),
                quantity: item.quantity,
                price: item.price,
                color: colorValue,
                raw_images: item.raw_images,
                product_category_name: item.product_category?.name || "",
                sku: item.sku,
                status: item.status || 'approved',
                badge: item.badge || 1,
                baseSkuHint: item.baseSkuHint || null
            });
            obj.supplier = suplierObj.supplier;
            obj.description = item.description;
            obj.whareHouse = suplierObj.others;

        });
        // obj.supplier = suplierVal;
        console.log(suplierObj, 'suplierObj')
        
        if (isSavingRef.current) return;
        isSavingRef.current = true;
        
        if (editDraftData) {
            updatePOMutation(
                { id: editDraftData._id, payload: obj },
                {
                    onSuccess: () => {
                        isSavingRef.current = false;
                        navigate(routeConstant.admin.roughListing.list.path);
                    },
                    onError: () => {
                        isSavingRef.current = false;
                    }
                }
            );
        } else {
            addPOMutation(obj, {
                onSuccess: () => {
                    isSavingRef.current = false;
                    sessionStorage.removeItem('temp_rough_listing_order');
                    navigate(routeConstant.admin.roughListing.list.path);
                },
                onError: () => {
                    isSavingRef.current = false;
                }
            });
        }
    };

    useEffect(() => {
        const isEditing = !!editDraftData;
        if (!isEditing) {
            try {
                if (PoListing && PoListing.length > 0 && PoListing.length <= 100) {
                    sessionStorage.setItem('temp_rough_listing_order', JSON.stringify(PoListing));
                } else {
                    sessionStorage.removeItem('temp_rough_listing_order');
                }
            } catch (e) {
                console.warn("Storage quota exceeded or error storing temp order:", e);
            }
        }
    }, [PoListing, editDraftData]);

    const savePoListing = (list, isAuto = false) => {
        if (isSavingRef.current) return;
        isSavingRef.current = true;
        setTasksAlreadyCreated(false);
        let obj = {
            order: [],
            description: editDraftData?.description || '',
            tasks_created: false
        };

        list.forEach((item) => {
            const isScreenProtector = String(item.product_category?.name || "").toLowerCase() === "screen protector";

            let colorValue = item.color;
            if (isScreenProtector) {
                colorValue = "Transparent";
            }
            obj.order.push({
                _id: item._id,
                product: cleanId(item.product),
                product_category: cleanId(item.product_category),
                compatiableBrand: cleanId(item.competebleBrand) || cleanId(item.compatiableBrand),
                sub_category: cleanId(item.sub_category),
                brand: cleanId(item.brand),
                quantity: item.quantity,
                price: item.price,
                color: colorValue,
                raw_images: item.raw_images,
                product_category_name: item.product_category?.name || "",
                sku: item.sku,
                status: item.status || 'pending',
                badge: item.badge || 1,
                task_created: item.task_created || false,
                baseSkuHint: item.baseSkuHint || null,
                parentChildSku: item.parentChildSku || null
            });
            obj.description = item.description;
        });

        if (editDraftData) {
            obj.status = editDraftData.status || 'draft';
            updatePOMutation(
                { id: editDraftData._id, payload: obj },
                {
                    onSuccess: (res) => {
                        isSavingRef.current = false;
                        const updatedDraft = res?.data?.data || res?.data;
                        if (updatedDraft) {
                            // Bug 2 fix: block PoList refetch from overwriting fresh badge data for 3s
                            recentLocalSaveRef.current = true;
                            setTimeout(() => { recentLocalSaveRef.current = false; }, 3000);
                            setEditDraftData(updatedDraft);
                            if (updatedDraft.order && Array.isArray(updatedDraft.order)) {
                                const mappedOrder = updatedDraft.order.map(item => ({
                                    _id: item._id,
                                    product: item.product,
                                    product_category: item.product_category,
                                    competebleBrand: item.compatiableBrand,
                                    sub_category: item.sub_category,
                                    brand: item.brand,
                                    quantity: item.quantity,
                                    price: item.price,
                                    color: item.color,
                                    raw_images: item.raw_images || [],
                                    description: updatedDraft.description || "",
                                    sku: item.sku,
                                    status: item.status || 'pending',
                                    badge: item.badge,
                                    task_created: item.task_created || false,
                                    parentChildSku: item.parentChildSku || null
                                }));
                                setPoListing(mappedOrder);
                            }
                        }
                    },
                    onError: () => {
                        isSavingRef.current = false;
                    }
                }
            );
        } else {
            assignSkuMutate(obj, {
                onSuccess: (res) => {
                    isSavingRef.current = false;
                    const createdDraft = res?.data?.data || res?.data;
                    if (createdDraft) {
                        // Bug 2 fix: block PoList refetch from overwriting fresh badge data for 3s
                        recentLocalSaveRef.current = true;
                        setTimeout(() => { recentLocalSaveRef.current = false; }, 3000);
                        setEditDraftData(createdDraft);
                        sessionStorage.removeItem('temp_rough_listing_order');
                        if (window.history?.replaceState) {
                            window.history.replaceState({ ...window.history.state, usr: { ...window.history.state?.usr, editData: createdDraft } }, '');
                        }
                        if (createdDraft.order && Array.isArray(createdDraft.order)) {
                            const mappedOrder = createdDraft.order.map(item => ({
                                _id: item._id,
                                product: item.product,
                                product_category: item.product_category,
                                competebleBrand: item.compatiableBrand,
                                sub_category: item.sub_category,
                                brand: item.brand,
                                quantity: item.quantity,
                                price: item.price,
                                color: item.color,
                                raw_images: item.raw_images || [],
                                description: createdDraft.description || "",
                                sku: item.sku,
                                status: item.status || 'pending',
                                badge: item.badge,
                                task_created: item.task_created || false,
                                parentChildSku: item.parentChildSku || null
                            }));
                            setPoListing(mappedOrder);
                        }
                    }
                },
                onError: () => {
                    isSavingRef.current = false;
                }
            });
        }
    };

    const handleContinue = () => {
        savePoListing(PoListing, false);
    };

    const getMissingFields = (item) => {
        const missing = [];

        const brandVal = item.brand?.name || (typeof item.brand === 'string' ? item.brand : null);
        if (!brandVal || !brandVal.trim()) missing.push("Brand");

        const compBrandVal = item.competebleBrand?.name || item.compatiableBrand?.name || (typeof item.competebleBrand === 'string' ? item.competebleBrand : null);
        if (!compBrandVal || !compBrandVal.trim()) missing.push("Compatible Brand");

        const productVal = item.product?.name || (typeof item.product === 'string' ? item.product : null);
        if (!productVal || !productVal.trim()) missing.push("Model/Product");

        const categoryVal = item.product_category?.name || (typeof item.product_category === 'string' ? item.product_category : null);
        if (!categoryVal || !categoryVal.trim()) missing.push("Category");

        const subCategoryVal = item.sub_category?.name || (typeof item.sub_category === 'string' ? item.sub_category : null);
        if (!subCategoryVal || !subCategoryVal.trim()) missing.push("Sub Category");

        const isScreenProtector = String(categoryVal || "").toLowerCase() === "screen protector";
        const colorVal = isScreenProtector ? (item.color || "Transparent") : item.color;
        if (!colorVal || (typeof colorVal === 'string' && !colorVal.trim())) missing.push("Color");

        const skuVal = item.sku;
        if (!skuVal || !skuVal.trim()) missing.push("SKU");

        return missing;
    };

    const proceedWithApproval = (index) => {
        const updated = [...PoListing];
        updated[index] = { ...updated[index], status: 'approved' };
        setPoListing(updated);
        toast.success("Item approved successfully!");
        if (editDraftData) {
            savePoListing(updated, true);
        }
    };

    const handleApproveItem = async (index) => {
        const missingFields = getMissingFields(PoListing[index]);
        if (missingFields.length > 0) {
            toast.error(`Cannot approve: please fill ${missingFields.join(', ')}`);
            return;
        }

        const item = PoListing[index];
        const payload = {
            roughListingId: editDraftData?._id,
            itemId: item._id,
            currentSku: item.sku,
            brand: item.brand?._id || item.brand,
            compatiableBrand: item.competebleBrand?._id || item.competebleBrand,
            product_category: item.product_category?._id || item.product_category,
            sub_category: item.sub_category?._id || item.sub_category,
            product: item.product?._id || item.product,
            color: item.color,
            product_category_name: item.product_category?.name || ""
        };

        setApprovingIndex(index);
        try {
            const result = await checkVariantExists(payload);
            if (result && result.exists) {
                setMatchedSkuAlert(result.sku);
                setPendingApproveIndex(index);
                setShowAlertModal(true);
            } else {
                proceedWithApproval(index);
            }
        } catch (error) {
            console.error("Error checking variant existence:", error);
            proceedWithApproval(index);
        } finally {
            setApprovingIndex(null);
        }
    };

    const handleDeclineItem = (index) => {
        const updated = [...PoListing];
        updated[index] = { ...updated[index], status: 'declined' };
        setPoListing(updated);
        toast.info("Item marked as declined (click Save Draft to persist)");
    };

    const handleAdminDone = () => {
        if (editDraftData) {
            const supplierObj = {
                supplier: editDraftData.supplier,
                others: editDraftData.whareHouse
            };
            SubmmitPo(supplierObj);
        }
    };

    const handleCreateTasks = () => {
        if (editDraftData?._id) {
            createTasksMutate(editDraftData._id, {
                onSuccess: (res) => {
                    const updatedDraft = res?.data?.data || res?.data;
                    if (updatedDraft) {
                        setEditDraftData(updatedDraft);
                        if (updatedDraft.order && Array.isArray(updatedDraft.order)) {
                            const mappedOrder = updatedDraft.order.map(item => ({
                                _id: item._id,
                                product: item.product,
                                product_category: item.product_category,
                                competebleBrand: item.compatiableBrand,
                                sub_category: item.sub_category,
                                brand: item.brand,
                                quantity: item.quantity,
                                price: item.price,
                                color: item.color,
                                raw_images: item.raw_images || [],
                                description: updatedDraft.description || "",
                                sku: item.sku,
                                status: item.status || 'pending',
                                badge: item.badge,
                                task_created: item.task_created || false
                            }));
                            setPoListing(mappedOrder);
                        }
                    }
                }
            });
        }
    };

    const allItemsReviewed = PoListing.length > 0 && PoListing.every(item => item.status && item.status !== 'pending');

    useEffect(() => {
        if (createTasksSuccess) {
            setTasksAlreadyCreated(true);
        }
    }, [createTasksSuccess]);

    const uploadMediaArray = async (files) => {
        try {
            setUploading(true);
            setUploadProgress(0);

            let cloneAvatarFile = [...avatarFileArray];
            let total = files.length;
            let done = 0;

            for (let file of files) {
                let fileBody = new FormData();
                fileBody.append("image", file);
                const imgfileArray = await uploadFileMedia(fileBody);
                const newurl = imgfileArray.data.url;
                cloneAvatarFile.push(newurl);

                done++;
                setUploadProgress(Math.round((done / total) * 100));
            }

            setAvatarFileArray(cloneAvatarFile);
        } catch (error) {
            console.error("Upload error:", error);
        } finally {
            setUploading(false);
        }
    };

    const fileInputRef = useRef(null);

    const downloadSampleExcel = () => {
        const sampleData = [
            {
                Sku: "WT-SAMPLE-001",
                Brand: "Apple",
                "Compatible Brands": "Apple",
                "Compatible Models": "iPhone 11",
                Category: "LCD",
                "Sub Category": "Incell",
                Color: "Black"
            }
        ];
        const worksheet = XLSX.utils.json_to_sheet(sampleData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sample RL");
        XLSX.writeFile(workbook, "RL_Sample_Format.xlsx");
    };

    const handleExcelUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setIsProcessingExcel(true);
        const reader = new FileReader();
        reader.onload = async (evt) => {
            try {
                const bstr = evt.target.result;
                const wb = XLSX.read(bstr, { type: 'binary' });
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                const rawRows = XLSX.utils.sheet_to_json(ws, { header: 1, defval: "" });

                if (!rawRows || rawRows.length === 0) {
                    toast.error("Excel sheet is empty!");
                    return;
                }

                // Find header row index
                let headerIdx = 0;
                for (let i = 0; i < Math.min(rawRows.length, 10); i++) {
                    const row = rawRows[i];
                    if (row && row.some(c => String(c).toLowerCase().includes('sku') || String(c).toLowerCase().includes('brand'))) {
                        headerIdx = i;
                        break;
                    }
                }

                const headerRow = rawRows[headerIdx] || [];
                console.log("Detected Header Row:", headerRow);

                let skuIdx = headerRow.findIndex(c => String(c).toLowerCase().includes('sku'));
                if (skuIdx === -1) skuIdx = 0;

                let brandIdx = headerRow.findIndex(c => {
                    const s = String(c).toLowerCase();
                    return s.includes('brand') && !s.includes('compat');
                });
                if (brandIdx === -1) brandIdx = 1;

                let compBrandIdx = headerRow.findIndex(c => {
                    const s = String(c).toLowerCase();
                    return s.includes('compat') && s.includes('brand');
                });
                if (compBrandIdx === -1) compBrandIdx = 2;

                let compModelIdx = headerRow.findIndex(c => {
                    const s = String(c).toLowerCase();
                    return s.includes('model') || (s.includes('compat') && s.includes('model'));
                });
                if (compModelIdx === -1) compModelIdx = 3;

                let catIdx = headerRow.findIndex(c => {
                    const s = String(c).toLowerCase();
                    return s.includes('cat') && !s.includes('sub');
                });
                if (catIdx === -1) catIdx = 4;

                let subCatIdx = headerRow.findIndex(c => String(c).toLowerCase().includes('sub'));
                if (subCatIdx === -1) subCatIdx = 5;

                let colorIdx = headerRow.findIndex(c => String(c).toLowerCase().includes('color') || String(c).toLowerCase().includes('colour'));
                if (colorIdx === -1) colorIdx = 6;

                console.log("Excel Column Indices:", { skuIdx, brandIdx, compBrandIdx, compModelIdx, catIdx, subCatIdx, colorIdx });

                // Pre-seed instant lookup maps
                const brandMap = new Map((listBrnd || []).map(b => [(b.name || '').toLowerCase(), b]));
                const compBrandMap = new Map((listCompetebleBrnd || []).map(b => [(b.name || '').toLowerCase(), b]));
                const catMap = new Map((listCategory || []).map(c => [(c.name || '').toLowerCase(), c]));
                const subCatMap = new Map((listSubCategory || []).map(s => [(s.name || '').toLowerCase(), s]));
                const productMap = new Map((listProduct || []).map(p => [(p.name || '').toLowerCase(), p]));
                const colorMap = new Map((colorarray || []).map(c => [((c.color || c.name || '')).toLowerCase(), c]));

                const rawVal = (v) => {
                    if (v === undefined || v === null) return '';
                    return String(v).trim();
                };

                const resolveEntity = (map, name) => {
                    if (!name) return null;
                    const found = map.get(name.toLowerCase());
                    if (found) {
                        return Object.assign({}, found, { label: found.name || name, value: found.name || name });
                    }
                    return { _id: name, name: name, label: name, value: name };
                };

                let processedItems = [];
                let errors = [];

                for (let i = headerIdx + 1; i < rawRows.length; i++) {
                    const row = rawRows[i];
                    if (!row || !Array.isArray(row)) continue;

                    const skuVal = rawVal(row[skuIdx]);

                    if (!skuVal) {
                        const hasAnyVal = row.some(v => v !== undefined && String(v).trim() !== "");
                        if (!hasAnyVal) continue; // skip blank rows
                        continue;
                    }

                    let brandName = rawVal(row[brandIdx]);
                    let compBrandName = rawVal(row[compBrandIdx]);
                    let modelName = rawVal(row[compModelIdx]);
                    let catName = rawVal(row[catIdx]);
                    let subCatName = rawVal(row[subCatIdx]);
                    let colorName = rawVal(row[colorIdx]);

                    // Resolve exact entity objects (null if empty, preserving "NA" / exact text as is)
                    const brand = resolveEntity(brandMap, brandName);
                    const competebleBrand = resolveEntity(compBrandMap, compBrandName);
                    const product_category = resolveEntity(catMap, catName);
                    const sub_category = resolveEntity(subCatMap, subCatName);
                    const product = resolveEntity(productMap, modelName);
                    const color = colorName ? (colorMap.get(colorName.toLowerCase())?.color || colorName) : "";

                    processedItems.push({
                        product: product,
                        brand: brand,
                        competebleBrand: competebleBrand,
                        compatiableBrand: competebleBrand,
                        product_category: product_category,
                        sub_category: sub_category,
                        quantity: 1,
                        price: 0,
                        description: "",
                        color: color,
                        sku: skuVal,
                        raw_images: [],
                        badge: 1,
                        status: 'approved'
                    });
                }

                if (errors.length > 0) {
                    toast.error(`Some rows had issues:\n${errors.slice(0, 5).join('\n')}${errors.length > 5 ? `\n...and ${errors.length - 5} more` : ''}`);
                }

                if (processedItems.length > 0) {
                    setPoListing(prev => {
                        let updatedList = [...prev];
                        let updatedCount = 0;
                        let addedCount = 0;

                        for (const item of processedItems) {
                            const existingIdx = updatedList.findIndex(it => (it.sku || '').toString().trim().toLowerCase() === item.sku.toLowerCase());
                            if (existingIdx !== -1) {
                                updatedList[existingIdx] = {
                                    ...updatedList[existingIdx],
                                    product: item.product,
                                    brand: item.brand,
                                    competebleBrand: item.competebleBrand,
                                    compatiableBrand: item.compatiableBrand,
                                    product_category: item.product_category,
                                    sub_category: item.sub_category,
                                    color: item.color,
                                    sku: item.sku
                                };
                                updatedCount++;
                            } else {
                                updatedList.push(item);
                                addedCount++;
                            }
                        }

                        if (editDraftData) {
                            savePoListing(updatedList, true);
                        }

                        toast.success(`Excel processed: ${addedCount} added, ${updatedCount} updated successfully!`);
                        return updatedList;
                    });
                }

            } catch (err) {
                console.error(err);
                toast.error("Failed to parse Excel file.");
            } finally {
                setIsProcessingExcel(false);
                if (fileInputRef.current) {
                    fileInputRef.current.value = "";
                }
            }
        };
        reader.readAsBinaryString(file);
    };

    const transparentOption = {
        label: "Transparent",
        value: "transparent"
    }

    const handleDeletePoItem = (indexToDelete) => {
        const updatedList = PoListing.filter((_, index) => index !== indexToDelete);
        setPoListing(updatedList);
        if (editingIndex === indexToDelete) {
            setEditingIndex(null);
            formik.resetForm();
            setAvatarFileArray([]);
        } else if (editingIndex > indexToDelete) {
            setEditingIndex(editingIndex - 1);
        }
        if (editDraftData) {
            savePoListing(updatedList, true);
        }
    };

    const populateFormFields = (item) => {
        // Brand
        if (item.brand) {
            setFieldValue('brand', { ...item.brand, label: item.brand.name, value: item.brand.name });
        } else {
            setFieldValue('brand', '');
        }
        // Compatible Brand
        if (item.competebleBrand) {
            setFieldValue('competebleBrand', { ...item.competebleBrand, label: item.competebleBrand.name, value: item.competebleBrand.name });
            setModelList(listProduct?.filter((ii) => item.competebleBrand._id === (ii?.compatiableBrand?._id || ii?.compatiableBrand)) || []);
        } else {
            setFieldValue('competebleBrand', '');
            setModelList(listProduct || []);
        }
        // Model
        if (item.product) {
            setFieldValue('model', { ...item.product, label: item.product.name, value: item.product.name });
        } else {
            setFieldValue('model', '');
        }
        // Product Category
        if (item.product_category) {
            setFieldValue('ProductCategory', { ...item.product_category, label: item.product_category.name, value: item.product_category.name });
            setSubCatList(listSubCategory?.filter((ii) => item.product_category._id === (ii?.category?._id || ii?.category)) || []);
        } else {
            setFieldValue('ProductCategory', '');
            setSubCatList(listSubCategory || []);
        }
        // Sub Category
        if (item.sub_category) {
            setFieldValue('SubCategory', { ...item.sub_category, label: item.sub_category.name, value: item.sub_category.name });
        } else {
            setFieldValue('SubCategory', '');
        }
        // Color
        if (item.color) {
            setFieldValue('color', { label: item.color, value: item.color });
        } else {
            setFieldValue('color', '');
        }
        // Price, Quantity, Description
        setFieldValue('price', item.price !== undefined ? String(item.price) : '0');
        setFieldValue('quantity', item.quantity !== undefined ? String(item.quantity) : '1');
        setFieldValue('description', item.description || '');
        // Badge
        setFieldValue('badge', item.badge || 1);
        // Images
        setAvatarFileArray(item.raw_images || []);
        // Scroll form into view
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleRowSelect = (item) => {
        populateFormFields(item);
        setEditingIndex(null);
    };

    const handleRowEdit = (item) => {
        populateFormFields(item);
        const index = item.globalIndex !== undefined ? item.globalIndex : PoListing.findIndex(p =>
            (p.product?._id || p.product) === (item.product?._id || item.product) &&
            (p.brand?._id || p.brand) === (item.brand?._id || item.brand) &&
            (p.competebleBrand?._id || p.competebleBrand) === (item.competebleBrand?._id || item.competebleBrand) &&
            (p.product_category?._id || p.product_category) === (item.product_category?._id || item.product_category) &&
            (p.sub_category?._id || p.sub_category) === (item.sub_category?._id || item.sub_category) &&
            p.color === item.color
        );
        setEditingIndex(index !== -1 ? index : null);
    };

    const handleAddGrandSku = (parentItem) => {
        if (!parentItem?.sku) {
            toast.error("Item does not have a SKU assigned yet.");
            return;
        }
        const parentSku = parentItem.sku.trim();
        // Child SKU format: wt000001g (wt + 6 digits + single letter a-z)
        if (!/^wt\d{6}[a-z]$/i.test(parentSku)) {
            toast.error("Can only create Sub-SKUs for base child variants (e.g. wt000001g).");
            return;
        }

        // Find used digits 0-9 for this exact parent SKU across current listing and all saved rough listings
        const usedDigits = new Set();
        const pattern = new RegExp(`^${parentSku}([0-9])$`, 'i');

        PoListing.forEach(it => {
            if (it.sku) {
                const m = it.sku.match(pattern);
                if (m) usedDigits.add(parseInt(m[1], 10));
            }
        });

        if (PoList) {
            PoList.forEach(rl => {
                rl.order?.forEach(it => {
                    if (it.sku) {
                        const m = it.sku.match(pattern);
                        if (m) usedDigits.add(parseInt(m[1], 10));
                    }
                });
            });
        }

        let nextDigit = null;
        for (let d = 0; d <= 9; d++) {
            if (!usedDigits.has(d)) {
                nextDigit = d;
                break;
            }
        }

        if (nextDigit === null) {
            toast.error(`Maximum 10 Sub-SKUs (0-9) already reached for ${parentSku}!`);
            return;
        }

        const nextSku = `${parentSku}${nextDigit}`;
        setGrandSkuTarget({
            parentItem,
            parentSku,
            nextSku,
            nextDigit
        });
        setEditingIndex(null);

        // Pre-fill form fields
        populateFormFields(parentItem);

        const targetBadge = parentItem.badge || 1;
        setFieldValue('badge', targetBadge);

        // Scroll to form
        window.scrollTo({ top: 120, behavior: 'smooth' });
        toast.info(`Creating Sub-SKU: ${nextSku} for ${parentSku}`);
    };

    const handleCancelGrandSku = () => {
        setGrandSkuTarget(null);
        formik.resetForm();
        setAvatarFileArray([]);
        setSelectedBaseSku(null);
    };

    const hasAutoSelectedSkuRef = useRef(false);
    useEffect(() => {
        const targetSku = location.state?.editSku;
        if (targetSku && PoListing.length > 0 && !hasAutoSelectedSkuRef.current) {
            const itemIdx = PoListing.findIndex(it => it.sku === targetSku);
            if (itemIdx !== -1) {
                hasAutoSelectedSkuRef.current = true;
                populateFormFields(PoListing[itemIdx]);
                setEditingIndex(itemIdx);
                toast.info(`Editing item for Task SKU: ${targetSku}`);
            }
        }
    }, [location.state?.editSku, PoListing]);
    const ADD_NEW_VALUE = "__add_new__";

    const selectStyles = {
        option: (base, state) => {
            const isAddNew = state.data?.value === ADD_NEW_VALUE;

            return {
                ...base,
                color: isAddNew ? "#0d6efd" : base.color,
                fontWeight: isAddNew ? 600 : base.fontWeight,
                // optional: hover/focus background
                backgroundColor: state.isFocused
                    ? isAddNew
                        ? "#e7f1ff"
                        : base.backgroundColor
                    : base.backgroundColor,
            };
        },
        singleValue: (base, state) => {
            const isAddNew = state.data?.value === ADD_NEW_VALUE;
            return {
                ...base,
                color: isAddNew ? "#0d6efd" : base.color,
                fontWeight: isAddNew ? 600 : base.fontWeight,
            };
        },
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    };
    const formatPrice = (price) => {
        const num = Number(price);
        if (isNaN(num)) return 'Rs 0.00';
        return `Rs ${num.toFixed(2)}`;
    };
    return (
        <DashboardWrapper>
            <div className={classNames(styles.UserContainer, 'text-start')}>
                <div>
                    {/* Metadata Header Info Bar */}
                    <div
                        className="d-flex flex-wrap align-items-center gap-4 mb-3 p-3 rounded-3"
                        style={{
                            background: editDraftData ? '#f8fafc' : '#eff6ff',
                            border: editDraftData ? '1px solid #e2e8f0' : '1px solid #bfdbfe',
                            fontSize: '13px',
                            boxShadow: '0 2px 6px rgba(0, 0, 0, 0.02)'
                        }}
                    >
                        <div className="d-flex align-items-center gap-1">
                            <span className="text-muted fw-semibold">Order#:</span>
                            {editDraftData?.order_number ? (
                                <span className="fw-bold text-primary">{editDraftData.order_number}</span>
                            ) : (
                                <span className="badge bg-primary text-white px-2 py-1" style={{ fontSize: '11px', borderRadius: '4px' }}>
                                    New Order
                                </span>
                            )}
                        </div>

                        <div className="d-flex align-items-center gap-1">
                            <span className="text-muted fw-semibold">Issue Date:</span>
                            <span className="fw-medium text-dark">
                                {editDraftData?.created_at
                                    ? moment(editDraftData.created_at).format('DD MMM YYYY')
                                    : editDraftData?.date || moment().format('DD MMM YYYY')}
                            </span>
                        </div>

                        {(editDraftData?.submitted_by?.name || editDraftData?.submitted_by?.email || (typeof editDraftData?.submitted_by === 'string' && editDraftData.submitted_by) || user?.name || user?.email) && (
                            <div className="d-flex align-items-center gap-1">
                                <span className="text-muted fw-semibold">Submitted By:</span>
                                <span className="fw-semibold text-dark">
                                    {editDraftData?.submitted_by?.name || editDraftData?.submitted_by?.email || (typeof editDraftData?.submitted_by === 'string' && editDraftData.submitted_by) || user?.name || user?.email}
                                </span>
                            </div>
                        )}

                        {(editDraftData?.approved_by?.name || editDraftData?.approved_by?.email || (typeof editDraftData?.approved_by === 'string' && editDraftData.approved_by)) && (
                            <div className="d-flex align-items-center gap-1">
                                <span className="text-muted fw-semibold">Approved By:</span>
                                <span className="fw-semibold text-success">
                                    {editDraftData.approved_by?.name || editDraftData.approved_by?.email || editDraftData.approved_by}
                                </span>
                            </div>
                        )}

                        <div className="d-flex align-items-center gap-1">
                            <span className="text-muted fw-semibold">Status:</span>
                            <span
                                className={`badge ${editDraftData?.status === 'completed' ? 'bg-success' : 'bg-primary'} bg-opacity-10 text-${editDraftData?.status === 'completed' ? 'success' : 'primary'} text-capitalize px-2 py-1`}
                                style={{ fontSize: '12px', borderRadius: '6px' }}
                            >
                                {editDraftData?.status || 'New Order'}
                            </span>
                        </div>
                    </div>

                    <div className={styles.Header}>
                        <Heading heading={'Add Rough Listing'} headingStyle={styles.Heading} />

                        <Select
                            options={skuOptions}
                            className={classNames(styles.SelectBox)}
                            classNamePrefix="custom-select"
                            isSearchable
                            isClearable
                            filterOption={customFilter}
                            placeholder="🔍 Search by SKU, Brand, Category, Model, Color..."
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                            onChange={(selected) => {
                                if (!selected) {
                                    // Cleared — reset baseSku tracking
                                    setSelectedBaseSku(null);
                                    return;
                                }
                                const data = selected?.fullData;
                                if (!data) return;

                                // Extract base SKU (e.g. 'wt000322' from 'wt000322a')
                                const baseSku = data.sku?.match(/^wt\d{6}/)?.[0] || null;
                                setSelectedBaseSku(baseSku);

                                if (data.brand) {
                                    setFieldValue("brand", {
                                        label: data.brand?.name,
                                        value: data.brand?.name,
                                        _id: data.brand?._id,
                                        ...data.brand,
                                    });
                                }

                                if (data.compatiableBrand) {
                                    setFieldValue("competebleBrand", {
                                        label: data.compatiableBrand?.name,
                                        value: data.compatiableBrand?.name,
                                        _id: data.compatiableBrand?._id,
                                        ...data.compatiableBrand,
                                    });
                                    setModelList(listProduct?.filter((ii) => data.compatiableBrand?._id === (ii?.compatiableBrand?._id || ii?.compatiableBrand)) || []);
                                }

                                if (data.product) {
                                    setFieldValue("model", {
                                        label: data.product?.name,
                                        value: data.product?.name,
                                        _id: data.product?._id,
                                        ...data.product,
                                    });
                                }

                                if (data.product_category) {
                                    setFieldValue("ProductCategory", {
                                        label: data.product_category?.name,
                                        value: data.product_category?.name,
                                        _id: data.product_category?._id,
                                        ...data.product_category,
                                    });
                                    setSubCatList(listSubCategory?.filter((ii) => data.product_category?._id === (ii?.category?._id || ii?.category)) || []);
                                    // Auto-set transparent for Screen Protector
                                    if (data.product_category?.name === "Screen Protector") {
                                        setFieldValue("color", transparentOption);
                                    } else if (data.color) {
                                        setFieldValue("color", { label: data.color, value: data.color });
                                    }
                                } else if (data.color) {
                                    setFieldValue("color", { label: data.color, value: data.color });
                                }

                                if (data.sub_category) {
                                    setFieldValue("SubCategory", {
                                        label: data.sub_category?.name,
                                        value: data.sub_category?.name,
                                        _id: data.sub_category?._id,
                                        ...data.sub_category,
                                    });
                                }

                                if (data.price) setFieldValue("price", data.price || "");
                                if (data.quantity) setFieldValue("quantity", data.quantity || "");
                            }}
                        />


                    </div>
                    {grandSkuTarget && (
                        <div
                            className="d-flex align-items-center justify-content-between p-3 mb-3 mx-3"
                            style={{
                                background: 'linear-gradient(135deg, #f0fdf4 0%, #e0f2fe 100%)',
                                border: '1.5px solid #0284c7',
                                borderRadius: '12px',
                                boxShadow: '0 4px 12px rgba(2, 132, 199, 0.1)'
                            }}
                        >
                            <div className="d-flex align-items-center gap-3">
                                <span style={{ fontSize: '26px' }}>🌿</span>
                                <div>
                                    <div style={{ fontWeight: '700', color: '#0369a1', fontSize: '15px' }}>
                                        Creating Sub-SKU: <span style={{ fontFamily: 'monospace', background: '#ffffff', padding: '2px 8px', borderRadius: '6px', border: '1px solid #7dd3fc', color: '#0c4a6e', fontWeight: 'bold' }}>{grandSkuTarget.nextSku}</span>
                                    </div>
                                    <div style={{ fontSize: '12px', color: '#0284c7' }}>
                                        Grand child of parent variant <strong>{grandSkuTarget.parentSku}</strong> (Sequence {grandSkuTarget.nextDigit} of 9)
                                    </div>
                                </div>
                            </div>
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-danger px-3 py-1 fw-bold"
                                onClick={handleCancelGrandSku}
                                style={{ borderRadius: '8px' }}
                            >
                                ✕ Cancel Sub-SKU
                            </button>
                        </div>
                    )}
                    <div className={classNames(`${theme}ModalBackground`, styles.Body, isLocked && styles.disable)}>
                        <div className={classNames(styles.TableFlex)}>
                            <div className={classNames(styles.InnerTableFlex)}>
                                <label className="LightFontColor Label style_InputLabel__lhse5">Brand</label>
                                <Select options={brandOptions}
                                    isSearchable
                                    isClearable
                                    value={values.brand}
                                    styles={selectStyles}
                                    menuPortalTarget={document.body}
                                    className={isEdits ? '' : classNames(styles.disable)} placeholder="Select Brand"
                                    onChange={async (item) => {
                                        if (!item) {
                                            await setFieldValue('brand', '');
                                            return;
                                        }
                                        if (item.value === "__add_new__") {
                                            setShowBrandModal(true);
                                            return;
                                        }
                                        setFieldValue('brand', item);
                                    }} />

                                <div className="Error"> {errors.brand && touched.brand ? errors.brand : ''}</div>
                            </div>
                            <div className={classNames(styles.InnerTableFlex)}>
                                <label className="LightFontColor Label style_InputLabel__lhse5">Competible Brand</label>
                                <Select
                                    options={listCompetebleBrndOptions}
                                    isSearchable
                                    isClearable
                                    value={values.competebleBrand}
                                    styles={selectStyles}
                                    menuPortalTarget={document.body}
                                    className={isEdits ? '' : classNames(styles.disable)}
                                    placeholder="Select Competible Brand"
                                    onChange={async (item) => {
                                        if (item?.value === "__add_new__") {
                                            setShowCompatibleBrandModal(true);
                                            return;
                                        }
                                        if (item) {
                                            setFieldValue('competebleBrand', item);
                                            console.log(item, "competebleBrand");
                                            setModelList(listProduct?.filter((ii) => item._id === (ii?.compatiableBrand?._id || ii?.compatiableBrand)) || []);
                                            // Only clear model if it doesn't match the selected compatible brand
                                            if (values.model && (values.model.compatiableBrand?._id || values.model.compatiableBrand) !== item._id) {
                                                setFieldValue('model', '');
                                            }
                                        } else {
                                            await setFieldValue('competebleBrand', '');
                                            setFieldValue('model', '');
                                            setModelList(listProduct || []);
                                        }
                                    }}
                                />
                                <div className="Error"> {errors.competebleBrand && touched.competebleBrand ? errors.competebleBrand : ''}</div>
                            </div>
                            <div className={classNames(styles.InnerTableFlex)}>
                                <label className="LightFontColor Label style_InputLabel__lhse5">Model </label>
                                <Select
                                    className={isEdits ? '' : classNames(styles.disable)}
                                    options={ModelListOptions}
                                    isSearchable
                                    isClearable
                                    value={values.model}
                                    styles={selectStyles}
                                    menuPortalTarget={document.body}
                                    placeholder="Select Model"
                                    onChange={(item) => {
                                        if (item?.value === "__add_new__") {
                                            setShowModelModal(true);
                                            return;
                                        }
                                        if (item) {
                                            setFieldValue('model', item);
                                            if (!values.competebleBrand) {
                                                const compBrandId = item.compatiableBrand?._id || item.compatiableBrand;
                                                if (compBrandId) {
                                                    const foundComp = listCompetebleBrnd?.find(b => b._id === compBrandId);
                                                    if (foundComp) {
                                                        setFieldValue('competebleBrand', {
                                                            ...foundComp,
                                                            label: foundComp.name,
                                                            value: foundComp.name
                                                        });
                                                    }
                                                }
                                            }
                                        } else {
                                            setFieldValue('model', '');
                                        }
                                    }}
                                />
                                <div className="Error"> {errors.model && touched.model ? errors.model : ''}</div>
                            </div>

                            <div className={classNames(styles.InnerTableFlex)}>
                                <label className="LightFontColor Label style_InputLabel__lhse5">Product Category </label>

                                <Select
                                    className={isEdits ? '' : classNames(styles.disable)}
                                    options={listCategoryOptions}
                                    isSearchable
                                    isClearable
                                    value={values.ProductCategory}
                                    styles={selectStyles}
                                    menuPortalTarget={document.body}
                                    placeholder={'Select Product Category'}
                                    onChange={async (item) => {
                                        if (item?.value === "__add_new__") {
                                            setShowCatModal(true);
                                            return;
                                        }
                                        if (item) {
                                            setFieldValue('ProductCategory', item);
                                            setSubCatList(listSubCategory?.filter((ii) => item._id === (ii?.category?._id || ii?.category)) || []);
                                            // Only clear SubCategory if it doesn't match the selected category
                                            if (values.SubCategory && (values.SubCategory.category?._id || values.SubCategory.category) !== item._id) {
                                                setFieldValue('SubCategory', '');
                                            }
                                            if (item.label === "Screen Protector") {
                                                setFieldValue("color", transparentOption);
                                            }
                                        } else {
                                            await setFieldValue('ProductCategory', '');
                                            setFieldValue('SubCategory', '');
                                            setSubCatList(listSubCategory || []);
                                        }
                                    }}
                                />
                                <div className="Error"> {errors.ProductCategory && touched.ProductCategory ? errors.ProductCategory : ''}</div>
                            </div>

                            <div className={classNames(styles.InnerTableFlex)}>
                                <label className="LightFontColor Label style_InputLabel__lhse5">Product Sub Category </label>
                                <Select
                                    className={isEdits ? '' : classNames(styles.disable)}
                                    options={SubCatlListOptions}
                                    isSearchable
                                    isClearable
                                    value={values.SubCategory}
                                    styles={selectStyles}
                                    menuPortalTarget={document.body}
                                    placeholder={'Select Sub Category'}
                                    formatOptionLabel={(option) => (
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <span style={{ marginRight: '8px' }}>{option.label}</span>
                                            {option.image && option.value !== "__add_new__" && (
                                                <img 
                                                    src={option.image} 
                                                    alt="" 
                                                    className={styles.dropdownImage}
                                                />
                                            )}
                                        </div>
                                    )}
                                    onChange={(item) => {
                                        if (item?.value === "__add_new__") {
                                            setShowSubCatModal(true);
                                            return;
                                        }
                                        if (item) {
                                            setFieldValue('SubCategory', item);
                                            if (!values.ProductCategory) {
                                                const catId = item.category?._id || item.category;
                                                if (catId) {
                                                    const foundCat = listCategory?.find(c => c._id === catId);
                                                    if (foundCat) {
                                                        setFieldValue('ProductCategory', {
                                                            ...foundCat,
                                                            label: foundCat.name,
                                                            value: foundCat.name
                                                        });
                                                        if (foundCat.name === "Screen Protector") {
                                                            setFieldValue("color", transparentOption);
                                                        }
                                                    }
                                                }
                                            }
                                        } else {
                                            setFieldValue('SubCategory', '');
                                        }
                                    }}
                                />
                                <div className="Error"> {errors.SubCategory && touched.SubCategory ? errors.SubCategory : ''}</div>
                            </div>
                            <div className={classNames(styles.InnerTableFlex)}>
                                <label className="LightFontColor Label style_InputLabel__lhse5">Product Color <span className={classNames(styles.warn)}>{values.ProductCategory?.label === "Screen Protector" && ` Not For This Category!`}</span></label>
                                <Select
                                    className={
                                        isEdits ? '' : classNames(styles.disable)
                                    }
                                    options={colorarrayOptions}
                                    isSearchable
                                    isClearable
                                    value={values.ProductCategory?.label === "Screen Protector" ? "Transparent" : values.color}

                                    placeholder="Select Color"
                                    styles={selectStyles}
                                    menuPortalTarget={document.body}

                                    isDisabled={values.ProductCategory?.label === "Screen Protector"}   // 🔒 disable select

                                    onChange={(item) => {
                                        if (item?.value === "__add_new__") {
                                            setShowColorModal(true);
                                            return;
                                        }
                                        if (!item) {
                                            setFieldValue("color", '');
                                            return;
                                        }
                                        // Only update if NOT screen protector
                                        if (values.ProductCategory?.label === "Screen Protector") {
                                            setFieldValue("color", transparentOption);
                                        } else {
                                            setFieldValue("color", item);
                                        }
                                    }}
                                />

                                <div className="Error"> {errors.color && touched.color ? errors.color : ''}</div>
                            </div>

                            <div className={classNames(styles.InnerTableFlex)}>
                                <label className="LightFontColor Label style_InputLabel__lhse5">Batch</label>
                                <Select
                                    className={isEdits ? '' : classNames(styles.disable)}
                                    options={badgeOptions}
                                    value={badgeOptions.find(o => o.value === values.badge) || { label: `Batch ${values.badge || 1}`, value: values.badge || 1 }}
                                    styles={selectStyles}
                                    menuPortalTarget={document.body}
                                    placeholder="Select Batch"
                                    onChange={(item) => {
                                        if (item) {
                                            setFieldValue('badge', item.value);
                                        }
                                    }}
                                />
                            </div>

                            {/* <div className={classNames(styles.InnerTableFlex)}>
                                <label className="LightFontColor Label style_InputLabel__lhse5">Please Select Currency</label>
                                
                                <Select
                                    className={values.SubCategory && isEdits ? '' : classNames(styles.disable)}
                                    options={[]}
                                    isSearchable
                                    isClearable
                                    value={values.currency}
                                    placeholder={'Select Currency'}
                                    onChange={(item) => {
                                        setFieldValue('currency', item[0]);
                                        
                                    }}
                                />
                                <div className="Error"> {errors.currency && touched.currency ? errors.currency : ''}</div>
                            </div> */}
                            {false && (
                                <>
                                    <div className={classNames(styles.InnerTableFlex)}>
                                        <CustomInput
                                            label={'Price'}
                                            type={'number'}
                                            placeholder={'e.g. 123'}
                                            value={values.price}
                                            onChange={handleChange('price')}
                                            CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle, `${isEdits ? '' : styles.disable}`)}
                                            CustomLabelStyle={styles.CustomLabelStyle}
                                            InputContainerStyle={styles.InputContainerStyle}
                                            error={errors.price && touched.price ? errors.price : ''}
                                        />
                                    </div>

                                    <div className={classNames(styles.InnerTableFlex)}>
                                        <CustomInput
                                            label={'Quantity'}
                                            placeholder={'123'}
                                            value={values.quantity}
                                            type={'number'}
                                            onChange={handleChange('quantity')}
                                            CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle, `${isEdits ? '' : styles.disable}`)}
                                            CustomLabelStyle={styles.CustomLabelStyle}
                                            InputContainerStyle={styles.InputContainerStyle}
                                            error={errors.quantity && touched.quantity ? errors.quantity : ''}
                                        />
                                    </div>
                                </>
                            )}
                            <div className={classNames(styles.InnerTableFlex)}>
                                <CustomInput
                                    label={'Description'}
                                    placeholder={'Type Something...'}
                                    value={values.description}
                                    onChange={handleChange('description')}
                                    CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle, `${isEdits ? '' : styles.disable}`)}
                                    CustomLabelStyle={styles.CustomLabelStyle}
                                    InputContainerStyle={styles.InputContainerStyle}
                                />
                            </div>
                            <label>Raw Images</label>
                            <UploadAvatarArray
                                setAvatarFileArray={setAvatarFileArray}
                                UploadedFile={avatarFile}
                                avatarFileArray={avatarFileArray}
                                setArray={uploadMediaArray}
                                setFile={setAvatarFile}
                                selectedImg={selectedImg}
                                setSelectedImg={setSelectedImg}
                            />
                            {uploading && (
                                <div className="mt-2 d-flex align-items-center">
                                    <div className="spinner-border text-primary me-2" role="status" />
                                    <span>Uploading... {uploadProgress}%</span>
                                </div>
                            )}
                        </div>
                        <AddBrand show={showBrandModal} datatable={listBrnd} handleClose={closeProductHandler} onSuccessAdd={(val) => handleSuccessAdd('brand', val)} />
                        <AddCompetibleBrand show={showCompatibleBrandModal} datacpmpatible={listCompetebleBrnd} handleClose={closeProductHandler} onSuccessAdd={(val) => handleSuccessAdd('competebleBrand', val)} />
                        <AddCategory show={showCatModal} datatable={listCategory} handleClose={closeProductHandler} onSuccessAdd={(val) => handleSuccessAdd('category', val)} />
                        <AddSubCategory show={showSubCatModal} datatable={listSubCategory} selectedCategory={values.ProductCategory} handleClose={closeProductHandler} onSuccessAdd={(val) => handleSuccessAdd('subCategory', val)} />
                        <AddColors show={showColorModal} datatable={colorlist} handleClose={closeProductHandler} onSuccessAdd={(val) => handleSuccessAdd('color', val)} />
                        <AddProduct show={showModelModal} datatable={listProduct} selectedCompatibleBrand={values.competebleBrand} handleClose={closeProductHandler} onSuccessAdd={(val) => handleSuccessAdd('model', val)} />

                        <div className={classNames(styles.ButtonContainer, 'd-flex justify-content-between align-items-center mb-3')}>
                            <CustomButton 
                                text={grandSkuTarget ? `Add Sub-SKU (${grandSkuTarget.nextSku})` : (editingIndex !== null ? (editDraftData ? 'Update & Sync Task' : 'Update Item') : 'Add Item')} 
                                containerStyle={classNames(styles.SubmitBtn, 'w-auto px-4')} 
                                style={{ minWidth: 'max-content', width: 'auto', whiteSpace: 'nowrap' }}
                                submitHandle={handleSubmit} 
                            />
                            
                            <div className="d-flex gap-3">
                                <button type="button" className="btn btn-outline-primary fw-bold" onClick={downloadSampleExcel}>
                                    Download Sample Format
                                </button>
                                
                                <input 
                                    type="file" 
                                    accept=".xlsx, .xls" 
                                    ref={fileInputRef} 
                                    style={{ display: 'none' }} 
                                    onChange={handleExcelUpload} 
                                
                                />
                                <button 
                                    type="button" 
                                    className="btn btn-success fw-bold d-flex align-items-center gap-2" 
                                    disabled={isProcessingExcel}
                                    onClick={() => fileInputRef.current?.click()}
                                >
                                    {isProcessingExcel && <div className="spinner-border spinner-border-sm" role="status" />}
                                    {isProcessingExcel ? 'Processing Excel...' : 'Upload Excel'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <InnerRlTable
                    PoList={PoListing}
                    OffPage={true}
                    setIsEdit={setIsEdit}
                    handleDelete={handleDeletePoItem}
                    onRowSelect={isLocked ? undefined : handleRowSelect}
                    onRowEdit={handleRowEdit}
                    isAdminReview={!!editDraftData}
                    handleApproveItem={handleApproveItem}
                    handleDeclineItem={handleDeclineItem}
                    isLocked={isLocked}
                    approvingIndex={approvingIndex}
                    onAddGrandSku={handleAddGrandSku}
                    onApplyBatchFields={(badgeNumber, sourceItem) => {
                        const updated = PoListing.map((item, idx) => {
                            if ((item.badge || 1) !== badgeNumber) return item;
                            // Skip the source item itself
                            if (sourceItem.globalIndex !== undefined ? idx === sourceItem.globalIndex : item === sourceItem) return item;
                            return {
                                ...item,
                                brand: sourceItem.brand,
                                competebleBrand: sourceItem.competebleBrand || sourceItem.compatiableBrand,
                                compatiableBrand: sourceItem.competebleBrand || sourceItem.compatiableBrand,
                                product_category: sourceItem.product_category,
                                sub_category: sourceItem.sub_category,
                                product: sourceItem.product,
                                sku: undefined,
                            };
                        });
                        setPoListing(updated);
                        if (editDraftData) savePoListing(updated, true);
                        toast.success(`All items in Batch ${badgeNumber} updated successfully!`);
                    }}
                />

                {PoListing.length > 0 && (
                    <div className={classNames(styles.ButtonContainer, 'd-flex justify-content-start gap-3')}>
                        {editDraftData && !hasItemsWithoutSku ? (
                            <>
                                {allItemsReviewed && (
                                    <>
                                        <CustomButton
                                            text={'Done'}
                                            containerStyle={styles.SubmitBtn}
                                            submitHandle={handleAdminDone}
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-success fw-bold px-4"
                                            style={{
                                                height: '40px',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                opacity: (editDraftData?.tasks_created || tasksAlreadyCreated || createTasksLoading) ? 0.5 : 1,
                                                pointerEvents: (editDraftData?.tasks_created || tasksAlreadyCreated || createTasksLoading) ? 'none' : 'auto'
                                            }}
                                            disabled={editDraftData?.tasks_created || tasksAlreadyCreated || createTasksLoading}
                                            onClick={handleCreateTasks}
                                        >
                                            {createTasksLoading ? 'Creating...' : (editDraftData?.tasks_created || tasksAlreadyCreated) ? '✓ Tasks Created' : 'Create Task'}
                                        </button>
                                    </>
                                )}
                                <CustomButton
                                    text={isSaving ? 'Saving...' : 'Save Draft'}
                                    containerStyle={styles.SubmitBtn}
                                    submitHandle={() => {
                                        if (!isSaving && isRestrictActions(screenEnum.rough_listing, screenActionEnum.create)) {
                                            handleContinue();
                                        }
                                    }}
                                />
                            </>
                        ) : (
                            <>
                                <CustomButton
                                    text={isSaving ? 'Saving...' : (editDraftData ? 'Save Draft' : 'Continue')}
                                    containerStyle={styles.SubmitBtn}
                                    submitHandle={() => {
                                        if (!isSaving && isRestrictActions(screenEnum.rough_listing, screenActionEnum.create)) {
                                            handleContinue();
                                        }
                                    }}
                                />
                                {!editDraftData && (user?.user?.authorize === roleEnum.admin || hasActionPermission(screenEnum.rough_listing, screenActionEnum.create)) && (
                                    <CustomButton
                                        text={'Add Supplier'}
                                        containerStyle={styles.SubmitBtn}
                                        submitHandle={() => {
                                            if (isRestrictActions(screenEnum.rough_listing, screenActionEnum.create)) {
                                                setShowModal(!modalShow);
                                            }
                                        }}
                                    />
                                )}
                            </>
                        )}
                        <PurchaseOrderSuplierModal show={modalShow} handleClose={() => setShowModal(!modalShow)} SubmmitPo={SubmmitPo} setSupplierVal={setSupplierVal} />
                        {/* <AddBrand show={showBrandModal} handleClose={() => setShowBrandModal(false)} /> */}
                        
                        <Modal show={showAlertModal} onHide={() => setShowAlertModal(false)} centered>
                            <Modal.Header closeButton>
                                <Modal.Title className="text-danger fw-bold">⚠️ Warning: Duplicate SKU Detected</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <p style={{ fontSize: '15px', color: '#1e293b' }}>
                                    This product details combo (brand, model, color, category, subcategory) already exists in the catalog with SKU: 
                                    <strong className="text-primary ms-1">{matchedSkuAlert}</strong>.
                                </p>
                                <p style={{ fontSize: '14px', color: '#64748b' }}>
                                    Would you still like to approve this item, or would you prefer to decline/change it?
                                </p>
                            </Modal.Body>
                            <Modal.Footer>
                                <button type="button" className="btn btn-danger fw-semibold" onClick={() => {
                                    setShowAlertModal(false);
                                    handleDeclineItem(pendingApproveIndex);
                                }}>
                                    Decline Item
                                </button>
                                <button type="button" className="btn btn-secondary fw-semibold" onClick={() => {
                                    setShowAlertModal(false);
                                }}>
                                    Go Back & Edit
                                </button>
                                <button type="button" className="btn btn-success fw-bold text-white" onClick={() => {
                                    setShowAlertModal(false);
                                    proceedWithApproval(pendingApproveIndex);
                                }}>
                                    Approve Anyway
                                </button>
                            </Modal.Footer>
                        </Modal>

                    </div>
                )}
            </div>
            {isProcessingExcel && <OverlayLoading />}
            {POLoading && <OverlayLoading />}
            {/* Bug 3 fix: non-blocking save indicator (was full-screen overlay, blocking all UI during server-busy retries) */}
            {(assignSkuLoading || updatePOLoading) && (
                <div style={{
                    position: 'fixed', bottom: 24, right: 24, zIndex: 9999,
                    background: '#1e293b', color: '#fff', borderRadius: 12,
                    padding: '10px 18px', fontSize: 13,
                    display: 'flex', alignItems: 'center', gap: 8,
                    boxShadow: '0 4px 20px rgba(0,0,0,0.25)'
                }}>
                    <span className="spinner-border spinner-border-sm" style={{ width: 14, height: 14 }} />
                    Saving...
                </div>
            )}
            {createTasksLoading && <OverlayLoading />}



        </DashboardWrapper>
    );
}
